import {Injectable} from '@angular/core';
import {UserService} from "../services/user.service";
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable()
export class TradingService {

    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router, private userService: UserService) {
    }
    public updateAdminUser(obj): Observable<any> {
        return this.userService.userequest('post', 'updateadminuser',obj);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/trading.service.ts